module.exports = __webpack_public_path__ + "static/media/walter_benitez.64aab8a1.jpg";